/* global ace */
import $ from 'jquery';

const AceEditor = {
    version: '1.2.7',
    theme: 'ace/theme/ace-openclassrooms',
  },
  basePath = '//cdnjs.cloudflare.com/ajax/libs/ace/' + AceEditor.version;
let scriptLoadPromise;

AceEditor.url = {
  main: basePath + '/ace.js',
  staticHighlight: basePath + '/ext-static_highlight.js',
};

function getFixedUrl(urlName) {
  var url = AceEditor.url[urlName];

  if (!document.location.protocol.match(/http/)) {
    url = 'https:' + url;
  }

  return url;
}

function preconfigAce() {
  ace.config.set('basePath', basePath);
  ace.config.set('modePath', basePath);
  ace.config.set('themePath', '/legacy/js');
  ace.config.set('workerPath', basePath);
}

AceEditor.load = function () {
  if (!scriptLoadPromise) {
    scriptLoadPromise = $.Deferred();

    $.ajax({
      dataType: 'script',
      cache: true,
      url: getFixedUrl('main'),
    }).done(function () {
      $.ajax({
        dataType: 'script',
        cache: true,
        url: getFixedUrl('staticHighlight'),
      }).done(function () {
        preconfigAce();
        scriptLoadPromise.resolve(ace);
      });
    });
  }

  return scriptLoadPromise;
};

export default AceEditor;
